import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { mergeRefs } from '@/helpers/mergeRefs';
import { getComponentPadding } from '@/utils/get-component-padding';
import clsx from 'clsx';
import * as React from 'react';
import { twMerge } from 'tailwind-merge';
const showAfterHydrationClass = '[&_*[data-show-after-hydration]]:opacity-0';
const SectionWrapper = React.forwardRef(({ children, className, containerClassName, theme, topPadding = false, bottomPadding = false, width = 'contained', innerRef, background = 'solid', isInTimeline, isInEditor, ...otherProps }, externalRef) => {
    const ref = React.useRef(null);
    /*
     * Components are rendered on the server, however animations all use effects meaning they don't run
     * until hydration. This means elements are visible for a split second before the animations start.
     * A `data-show-after-hydration` attribute exists which sets the elements opacity to 0 by default. This
     * effect removes the class, meaning the children are not hidden.
     */
    React.useLayoutEffect(() => {
        ref.current?.classList.remove(showAfterHydrationClass);
    });
    return (_jsx("div", { ref: mergeRefs(ref, externalRef), className: `${theme} ${showAfterHydrationClass}`, children: _jsx("div", { className: clsx({
                'bg-gradient-to-b from-gradient-dark to-gradient-light': background === 'a-to-b',
                'bg-gradient-to-t from-gradient-dark to-gradient-light': background === 'b-to-a',
                'bg-surface-primary': !background || background === 'solid',
            }, 'overflow-clip', containerClassName), children: _jsxs("section", { className: twMerge(width === 'contained' && 'site-container', getComponentPadding({ topPadding, bottomPadding }), isInTimeline && !isInEditor && 'grid h-dvh', // when inside timeline container all components MUST fill the viewport
                isInTimeline && isInEditor && 'grid h-screen-editor', className), ref: innerRef, ...otherProps, children: [width === 'contained' && children, width === 'full' && children] }) }) }));
});
SectionWrapper.displayName = 'SectionWrapper';
export default SectionWrapper;
